// extracted by mini-css-extract-plugin
export default {"container":"platform_container__O82uQ","header":"platform_header__AGSJ1","subHeader":"platform_subHeader__9yGrv","btn":"platform_btn__hFUTJ"};